export const APP_SURFACES = {
  INTERNAL: 'internal',
  CLIENT_PORTAL: 'client-portal',
}

export function getAppSurface() {
  const forcedSurface = String(import.meta.env.VITE_APP_SURFACE || '').trim().toLowerCase()
  if (forcedSurface === APP_SURFACES.CLIENT_PORTAL || forcedSurface === APP_SURFACES.INTERNAL) {
    return forcedSurface
  }

  if (typeof window === 'undefined') return APP_SURFACES.INTERNAL

  const hostname = window.location.hostname.toLowerCase()
  if (hostname === 'portal.veiga.law' || hostname === 'portal.localhost') {
    return APP_SURFACES.CLIENT_PORTAL
  }

  return APP_SURFACES.INTERNAL
}

export function isClientPortalSurface() {
  return getAppSurface() === APP_SURFACES.CLIENT_PORTAL
}
